module.exports = __webpack_public_path__ + "static/media/add.120537a8.svg";